module.exports = __webpack_public_path__ + "static/media/image.9ce6e773.webp";